import React, { useEffect, useRef, useState } from 'react';
import ModalLogo from '../../assets/images/modal_logo.png'
import 'animate.css'
import { t } from 'i18next';
import Arrow from "../../assets/images/arrow.png"
import RadioButtons from '../Kudzu_Plus_Components/RadioButtons';
import CloseIcon from '../../assets/images/CloseIcon.png'
import { useKeyDown } from '../../hooks/useKeyDown';
import { useNavigate } from 'react-router';
import Oops from '../../assets/images/Oops.png';
import logFirebaseEvents from '../../components/LogFirebaseEvents';
import { addLineBreaks } from '../../utils';
const SecurityCustomPopup = (props) => {
    const { isOpen, onClose, title, content, subtitle, isLogo, isClimbg, isIframe, Fullheight, defaultCornerRadius = true, isFooter = false, button1, button2, msgContent ,errorMessage } = props
    const modalRef = useRef(null);
    const [isclosed, setIsclosed] = useState(0);
    const navigate = useNavigate()
    const [loaded, setLoaded] = useState(0);
    const procArray = [{ displayText: "Text" }, { displayText: "Email" }]
    const [Proc, setProc] = useState('');
    const [localErrorMessage, setLocalErrorMessage] = useState('');


    const isiPhoneOriPad = () => /(iphone|ipad)/i.test(navigator.userAgent);
    const setProcFunction = (value) => {
        setLocalErrorMessage('');
        // debugger;
        if (value.displayText === "Text") {
            // logFirebaseEvents("text_and_email_authentication", "Text_Checked", "Text_Checked", "", "");
        }
        else if (value.displayText === "Email") {
            // logFirebaseEvents("text_and_email_authentication", "Email_Checked", "Email_Checked", "", "");
        }
        setProc(value.displayText)
    }

    useEffect(() => {
        // Update local state when errorMessage prop changes
        setLocalErrorMessage(errorMessage);
    }, [errorMessage]);

    useKeyDown(() => {
        if (Proc != '') {
            props?.onClickNext({ proc: Proc }); setProc('')
        }
    }, ["Enter"]);

    useEffect(() => {
        const handleOutsideClick = (event) => {
            if (event.target.classList.contains('modal')) {
                onClose();
            }
        };

        if (isOpen) {
            document.addEventListener('click', handleOutsideClick);
        }

        return () => {
            document.removeEventListener('click', handleOutsideClick);
        };
    }, [isOpen, onClose]);

    useEffect(() => {
        if (isOpen && modalRef.current) {
            setIsclosed(2)
            setTimeout(() => {
                setLoaded(1)
            }, 500);
        } else if (modalRef.current) {
            setIsclosed(3)
            modalRef.current.classList.remove('fade-in');
        }
    }, [isOpen]);

    if (!isOpen) {
        return null;
    }

    const handleClose = () => {
        navigate('/home')
        setIsclosed(1)
        setTimeout(() => {
            onClose();
        }, 500);
    };
    return (
        <div
            className="fixed top-0 left-0 w-full h-full flex justify-center items-center bg-[#324261] bg-opacity-90"
            style={{ zIndex: 200 }}
        >
            {isOpen && (
                <div
                    className={`absolute sm:pt-[130px] bottom-0 left-1/2 w-full transform -translate-x-1/2 rounded-md ${loaded ? ' overflow-y-auto ' : ''}`}
                    style={{
                        position: 'absolute',
                        top: isclosed == 2 ? '0px' : '2000px',
                        transition: 'top 1s ease-in-out'
                    }}
                >
                    <div
                        ref={modalRef}
                        className=" modal-container bg-card bg-[#262B3A] sm:rounded-tl-card-tr sm:rounded-br-card-bl  md:w-[778px] sm:w-[466px] w-[100%] mx-auto shadow-lg z-50 h-[100vh] sm:h-fit sm:mb-10  overflow-y-auto  " style={{ background: "#262B3A" }} >
                        <div className="modal-content text-left " >
                            <div className={`modal-body  h-[100%]  ${isIframe ? 'flex justify-center' : 'flex justify-center items-center '} sm:my-[60px] md:mt-[110px] mt-[68px] mb-[20%] `}>
                                <div className={` ${isIframe ? ' w-[85%] xsm:w-[100%]' : 'md:w-[430px] sm:w-[294px] xsm:w-[260px] w-[320px]'} `}>
                                    <div style={{ position: 'relative' }}>
                                        <div className='md:w-[430px] sm:w-[294px] xsm:w-[260px] w-[320px] '>
                                            {title}
                                            {subtitle}
                                        </div>
                                        {props?.subHeaderMsg &&
                                            <div className='md:w-[430px] sm:w-[294px] xsm:w-[260px] w-[320px] mt-4 '>
                                                {props.subHeaderMsg}
                                            </div>
                                        }
                                        {/* {content} */}
                                        <div className='md:w-[340px] sm:w-[294px] xsm:w-[240px] w-[320px] flex flex-col justify-start gap-7 mt-5 mb-12'>
                                            <div className='w-full flex flex-row'>
                                                <RadioButtons isRowOnMobileSrn={true} isTitle={false} name="deliveryMethod" options={procArray} frequency={Proc} onSelect={setProcFunction} />
                                            </div>
                                        </div>


                                        {localErrorMessage != "" && <div className="flex sm:mx-0 flex-row gap-4 justify-start mt-8 mb-28">
                                            <img src={Oops} alt="oops" className="md:w-[20px] md:h-[20px] sm:w-[14px]
        sm:h-[14px] w-[15px] h-[15px] mt-1 sm:mt-0 md:mt-1  self-start" />
                                            <p className={`font-hanken-grotesk font-[500] text-[16px]  
       leading-[24px] md:text-[18px] md:leading-[28px] sm:text-[12px] 
       sm:leading-[18px] text-white `}>
                                                <span className="text-[#30BC89] font-[600]
        lg:font-[600]"> Oops! </span>{localErrorMessage}</p>
                                        </div>}

                                        <div className='md:w-[430px] sm:w-[294px] xsm:w-[260px] w-[320px] mt-4  '>
                                       {msgContent}
                                       </div>

                                        <div className={`md:w-[550px] sm:w-[294px] xsm:w-[240px] w-[320px] flex flex-col justify-start gap-5 sm:mt-[20px] md:mt-[40px] sm:mb-[20px] md:mb-[20px]`}>
                                            <div className='lg:pt-20 md:pt-18 sm:pt-10 w-full'>
                                                <div className='flex justify-end w-full'>
                                                    <button type="button" className="font-hanken-grotesk sm:font-bold font-[600] lg:text-[18px] md:text-[17px] sm:text-[14px] text-[16px] text-[#4B70B9] cursor-pointer flex items-center " onClick={() => {
                                                        if (Proc == '') {
                                                            return;
                                                        }
                                                        props?.onClickNext({ proc: Proc }); setProc(''); logFirebaseEvents("Security_Custom_Popup", "Kudzu_Plus_Next_Clicked", "Kudzu_Plus_Next_Clicked", "", "");
                                                    }}>
                                                        {t('next')}
                                                        <img src={Arrow} className="md:w-[14px] sm:w-[11px] md:h-[14px] sm:h-[11px] w-[14px] h-[14px] ml-1" alt="Arrow" />
                                                    </button>
                                                </div>
                                            </div>
                                        </div>

                                        <span className={`absolute md:top-[-50px] sm:top-[-30px]  ${isIframe ? 'right-[9%] xsm:right-[9%] sm:right-[5%] md:right-[5%] lg:right-[5%] xl:right-[5%] top-[-68px]' : 'right-[2%] xsm:right-[-18%] sm:right-[-18%] md:right-[-24%] lg:right-[-27%] xl:right-[-25%] top-[-30px]'}`}>
                                            <button className="modal-close text-gray-500 hover:text-gray-800 cursor-pointer"
                                                onClick={handleClose}>
                                                <img src={CloseIcon} alt='closeIcon' className="h-[15px] w-[15px] opacity-[40%]" />
                                            </button>
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            )}

        </div>
    );
};

export default SecurityCustomPopup;